import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ModalController, Platform, Events} from 'ionic-angular';
import {BluetoothProvider} from "../../providers/bluetooth/bluetooth";
import {PrinterListPage} from "../printer-list/printer-list";
import {LoadingProvider} from "../../providers/loading/loading";


/**
 * Generated class for the BluetoothPrinterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-bluetooth-printer',
  templateUrl: 'bluetooth-printer.html',
})
export class BluetoothPrinterPage {

  public status = false;
  public printerName = null;
  private win: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public modal: ModalController, private printer: BluetoothProvider, private platform: Platform, public events: Events) {
    this.win = window;
    const {device = {}, status = false} = navParams.data;
    const{name = null} =  device;
    this.printerName = name;
    this.status = status;
    this.events.subscribe('printer-disconnected', data => {
      this.printerName = null;
      this.status = data;
      this.win.printerStatus = data;
    });

  }

  searchForPrinter() {
    this.platform.ready().then(() => {
      this.printer.search().then( data => {
          this.presentPrinterModal('PrinterListPage', {list: data})
      }).catch( error => {

      })
    })
  }


  presentPrinterModal(component, data) {
    const profileModal = this.modal.create(component, data);
    profileModal.onDidDismiss(data => {
      this.printerName = data.device.name;
      this.status = data.status;
      this.win.printerStatus = data;
      this.events.publish('printer-connected', data);
    });
    profileModal.present();
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/bluetooth-printer/bluetooth-printer.ts